// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { node, string } from 'prop-types'
import { castToString } from 'helpers/reduxFormFunctions'

const RenderSiteCell = ({ className, contents, label, id }) => (
  <div
    className={`path-summary-site-cell ${className}`}
    data-label={label}>
    <span
      className={'text-ellipsis'}
      id={id}>
      {castToString(contents)}
    </span>
  </div>
)

RenderSiteCell.propTypes = {
  className: string,
  contents: node,
  label: string.isRequired,
  id: string.isRequired,
}

RenderSiteCell.defaultProps = {
  className: '',
}

export default RenderSiteCell
